// POST /api/v2/conversion with the body CreateModal sends (shared by the
// studio). For a user without a plan or credits the server saves a locked
// cover instead of running it (`locked: true`); its page shows the
// unlock paywall. Errors propagate for the caller to map.
import axios from "axios";
import { requireIdToken } from "../../utils/firebaseAuth";
import { buildConversionRequestBody } from "@/components/modals/conversionRequest";

/* eslint-disable @typescript-eslint/no-explicit-any */

export interface CoverInput {
  selectedVoices: any[];
  selectedSongsList: any[];
  settings: any;
  // A Marble Run template (VideoOptions marbleRunTemplate); costs a coin.
  marbleRun?: any;
  voiceTimes?: { voice: string; start: number; end: number }[];
}

export const postCover = async ({
  selectedVoices,
  selectedSongsList,
  settings,
  marbleRun,
  voiceTimes,
}: CoverInput): Promise<{ shortid: string; locked: boolean }> => {
  const token = await requireIdToken();
  // { template } is the shape CreateModal's Marble Run picker sets; the
  // body builder turns it into template + videoTemplate {type:"marble_run"}.
  const res = await axios.post(
    `/api/v2/conversion`,
    buildConversionRequestBody({
      settings,
      selectedVoices,
      selectedSongsList,
      marbleRunTemplate: marbleRun ? { template: marbleRun } : null,
      voiceTimes,
    }),
    { headers: { Authorization: token } },
  );
  if (!res?.data?.shortid) {
    throw new Error("Conversion started but failed to get details.");
  }
  return { shortid: res.data.shortid, locked: !!res.data.locked };
};
